export const apiFolder = (game) => {
    let prefix
    if (game.video_sport_type === "baseball") {
        if (game.webapp_storage_type !== "wasabi") {
            prefix = process.env.REACT_APP_BASEBALL_API_QA
        } else {
            prefix = process.env.REACT_APP_BASEBALL_API
        }
    } else {
        if (game.webapp_storage_type !== "wasabi") {
            prefix = process.env.REACT_APP_API_QA
        } else {
            prefix = process.env.REACT_APP_API
        }
    }

    console.log("apiFolder", prefix)
    return prefix
}

export const videoPlayerBasePath = (game) => {
    let prefix = `/teams/${game.home_team.name}/games/${game.home_team.name}-${game.game_id}/`
    if (game.video_sport_type === "baseball") {
        if (game.webapp_storage_type !== "wasabi") {
            prefix = `${process.env.REACT_APP_BASEBALL_API_QA}${prefix}`
        } else {
            prefix = process.env.REACT_APP_BASEBALL_API + prefix
        }
    } else {
        if (game.webapp_storage_type !== "wasabi") {
            prefix = `${process.env.REACT_APP_API_QA}${prefix}`
        } else {
            prefix = process.env.REACT_APP_API + prefix
        }
    }
    return prefix
}
